// Turns the logged-in user's profile (GET /api/users/profile) into the public card shape CardView expects.
// `overrides` lets editors preview unsaved changes (e.g. { theme, accentColor }).
export function cardFromUser(user, overrides = {}) {
    if (!user) return null;
    const visible = (list = []) => list.filter((x) => x && x.isVisible !== false);
    return {
        uuid: user.cardUuid,
        theme: user.cardTheme || 'default',
        accentColor: user.cardAccentColor || null,
        verified: !!user.isVerified,
        exchangeEnabled: user.cardSettings?.exchangeEnabled !== false,
        profile: { ...(user.profile || {}) },
        photo: null, // the preview uses the original upload; the public card uses resized versions
        phoneNumbers: visible(user.phoneNumbers),
        emailAddresses: visible(user.emailAddresses),
        nonprofitOrganizations: visible(user.nonprofitOrganizations),
        socialMedia: user.socialMedia || {},
        accountEmail: user.isAccountEmailVisible ? user.email : null,
        ...overrides,
    };
}
